var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPowerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 28 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1275 0.170128C22.3722 0.311974 22.5615 0.532603 22.6646 0.795972C22.7677 1.05934 22.7784 1.34988 22.695 1.62013L18.1925 16.2501H26.5C26.7441 16.25 26.983 16.3214 27.187 16.4555C27.391 16.5896 27.5513 16.7805 27.6481 17.0046C27.7449 17.2287 27.7739 17.4763 27.7316 17.7168C27.6893 17.9572 27.5775 18.18 27.41 18.3576L7.41001 39.6076C7.21649 39.8134 6.95898 39.9476 6.67944 39.9883C6.39991 40.029 6.11483 39.9738 5.87069 39.8317C5.62654 39.6896 5.43771 39.469 5.33499 39.2059C5.23226 38.9427 5.2217 38.6525 5.30501 38.3826L9.80751 23.7501H1.50001C1.25587 23.7502 1.01705 23.6788 0.813025 23.5448C0.609 23.4107 0.448703 23.2198 0.351923 22.9956C0.255143 22.7715 0.226117 22.5239 0.268427 22.2835C0.310737 22.0431 0.422532 21.8203 0.59001 21.6426L20.59 0.392628C20.7833 0.187126 21.0404 0.0530493 21.3195 0.0121992C21.5987 -0.028651 21.8834 0.0261275 22.1275 0.167628V0.170128Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerIcon);
export default __webpack_public_path__ + "static/media/power_icon.ff465576.svg";
export { ForwardRef as ReactComponent };